import React, { useState } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { Auth } from 'aws-amplify'

import ResetPasswordForm from '../../components/ResetPasswordForm/ResetPasswordForm'

import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import { alpha } from '@mui/material/styles'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import useMediaQuery from '@mui/material/useMediaQuery'

import Textfield from '../../components/Forms/Textfield'

import useBodyClass from '../../hooks/useBodyClass'

import { Footer } from '../../components/Footer'

const initialFormValues = { email: '' }
const formValidation = Yup.object().shape({
  email: Yup.string().required('Email is Required')
})

const ForgotPasswordPage = () => {
  useBodyClass('o96-bg--space')
  const [reset, setReset] = useState(false)
  const [passedEmail, setPassedEmail] = useState('')
  const location = useLocation()
  const mostRecentFrom = location.state?.from

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    try {
      await Auth.forgotPassword(values.email)
      setSubmitting(false)
      setPassedEmail(values.email)
      setReset(true)
    } catch (e) {
      console.log(e)
      if (e.code === 'UserNotFoundException') {
        setErrors({ email: 'Sorry, this email could not be found.' })
      } else if (e.code === 'LimitExceededException') {
        setErrors({
          email:
            'Sorry, we cannot send a password reset link right now. Please try again after some time.'
        })
      }
      setSubmitting(false)
    }
  }
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'))

  return (
    <>
      <div
        className={`o96-body o96-body--with-centered-footer ${
          isMobile ? 'o96-body--mobile' : ''
        }`}
      >
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{
              mt: 5,
              px: 4,
              pt: 2,
              pb: 4,
              backgroundColor: theme =>
                alpha(theme.palette.background.default, 0.9),
              border: 1,
              borderRadius: 2,
              borderColor: theme => theme.palette.divider,
              maxWidth: 550
            }}
          >
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              align='center'
              sx={{
                mb: 1
              }}
            >
              {!reset ? 'Forgot Password' : 'Reset Password'}
            </Typography>
            <Typography
              variant='body2'
              align='center'
              sx={{
                px: 3,
                mb: 3
              }}
            >
              {!reset
                ? `Enter the email address associated with your Original96 account, and
          we'll send you a link to reset your password.`
                : 'Enter the verification code that we emailed to you and choose a new password.'}
            </Typography>
            {!reset ? (
              <>
                <Formik
                  initialValues={initialFormValues}
                  validationSchema={formValidation}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting, values, isValid }) => (
                    <Form>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Textfield name='email' type='email' label='Email' />
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            fullWidth
                            type='submit'
                            size='large'
                            disabled={isSubmitting || !isValid}
                            variant='contained'
                            sx={{ mb: { xs: 2, md: 0 } }}
                          >
                            Send Password Reset Link
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
                <Typography variant='body2' align='center' sx={{ mt: 2 }}>
                  Remember your password?{' '}
                  <Link
                    component={RouterLink}
                    to={{
                      pathname: '/sign-in'
                    }}
                    state={{ from: mostRecentFrom }}
                  >
                    Sign in
                  </Link>
                </Typography>
              </>
            ) : (
              <ResetPasswordForm passedEmail={passedEmail} />
            )}
          </Box>
        </Container>
      </div>
      <Footer theme={`centered`} />
    </>
  )
}

export default ForgotPasswordPage
